export default ((suggestion, key) => {
  let label;
  if (!suggestion) return null;
  if (typeof suggestion === 'string') {
    label = suggestion;
  } else if (typeof key === 'function') {
    label = key(suggestion);
  } else {
    label = suggestion[key];
  }
  return label;
});